import React,{} from 'react';

import {Spin} from "antd";


function PageLoading() {

    return (
        <div style={{textAlign:'center',marginTop:100}}><Spin size="large" /></div>
    );

}

export default PageLoading;

